import React from "react";

const ContactUs: React.FC = () => {
  return (
    <div style={{ padding: "2rem" }}>
      <h1>Contact Us</h1>
      <p>We’d love to hear from you! Reach out to us via:</p>
      <ul>
        <li>Phone: +968 95987986</li>
        <li>Email: team@dreamstriphub.com</li>
        <li>Location: Amirat Muscat, Oman</li>
      </ul>
      {/* Google Map Embed */}
      <div style={{ margin: "2rem 0" }}>
      <iframe
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3659.6420339579645!2d58.47402817406557!3d23.473373378860366!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e91fb8358dc4433%3A0x6210b4457faf9e21!2sDestination%20Dreams%20Travels!5e0!3m2!1sen!2som!4v1755078534674!5m2!1sen!2som"
  width="100%"
  height="450"
  style={{ border: 0 }}
  allowFullScreen
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
/>
 </div>

    </div>
  );
};

export default ContactUs;
